// @flow
import * as React from "react";
import { Route } from "react-router-dom";

import SectionHeader from "../commons/SectionHeader";
import Section from "../commons/Section";
import CoverPic from "../commons/CoverPic";

import { emptyOrder } from "./catalog";
import type { Order } from "./catalog";
import BottleDetail from "./BottleDetail";
import OrderForm from "./OrderForm";

type Props = {};

type State = {
  order: Order
};

class NosBouteilles extends React.Component<Props, State> {
  state = {
    order: emptyOrder()
  };

  onChangeQty = (name: string, type: string, qty: number) => {
    const { order } = this.state;
    order[name][type] = qty;
    this.setState({ order });
  };

  render() {
    const { order } = this.state;

    return (
      <div style={{}}>
        <SectionHeader>Nos bouteilles</SectionHeader>
        {/* <CoverPic src="pressoir.jpg" /> */}
        <Section>
          <OrderForm order={order} onChangeQty={this.onChangeQty} />
        </Section>
        <Route path="/bottles/:name" component={BottleDetail} />
      </div>
    );
  }
}

export default NosBouteilles;



// WEBPACK FOOTER //
// ./src/NosBouteilles/index.js